import { ThemeProvider } from "@climatepartner/components/Theme";
import { RouteObject } from "react-router-dom";

import { NETWORK_SUPPLIER_REGISTER_PATH } from "../../../shared/routing/paths/network";
import { themePalette } from "../../../shared/ui/theme-palette";
import { SupplierLandingPage } from "./registration/components/supplier-landing-page";

/**
 * Mounted outside AppLayout/AppShell so the Frontegg auth gate never intercepts it; supplies its own
 * ThemeProvider since AppShell — which normally provides the theme — is absent here.
 *
 * The multi-account (ACCOUNT_SELECTION) flow needs a real authenticated session, so
 * SupplierLandingPage redirects it to the authenticated /network/supplier/select-account route
 * (AIM-2632).
 */
export const SupplierPublicRoutes: RouteObject = {
  path: NETWORK_SUPPLIER_REGISTER_PATH,
  element: (
    <ThemeProvider theme={themePalette}>
      <SupplierLandingPage />
    </ThemeProvider>
  ),
};
